import axios from 'axios'
import qs from 'qs'

import request, { Res, TaiRes } from '@/utils/request'

// runWorkflowByCourseId
export const verityRoorunWorkflowByCourseIdmUser = (data: any, controller: AbortController) => {
  return axios.post<Res, Res>(`https://testapi.meishubao.com/api/aicenter/runWorkflowByCourseId`, qs.stringify(data), {
    signal: controller.signal,
    headers: {
      userid: localStorage.userid || 4157958
    }
  })
}
